import type { IModuleDefinition } from '@platform/core/types';
import type { ITypeStats } from './ITypeStats';

/**
 * Плитки й лічильники «Налаштувань» як у прототипі v4 (wsA.modules — кожен реалізований тип запису, поля — сума полів усіх типів):
 * реалізовані типи записів модулів (головні й дочірні, без спроєктованих і прихованих таблиць) і кількість їхніх полів (без прихованих —
 * службових полів даних, яких прототип не показує). Чиста функція.
 */
export function typeStats(definitions: readonly IModuleDefinition[]): ITypeStats {
  const types = definitions.flatMap((d) => d.recordTypes.filter((r) => r.status !== 'designed' && !r.hidden));
  return { types: types.length, fields: types.reduce((n, r) => n + r.fields.filter((f) => !f.hidden).length, 0) };
}
